import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconIntegrations: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconIntegrations"><Path d="M17.3105 12L9 20.3105L0.689453 12L9 3.68945L17.3105 12Z" fill="currentColor"/><Path d="M23.3105 12L15 20.3105L13 18.3105L19.3105 12L13 5.68945L15 3.68945L23.3105 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconIntegrations;
